import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <p className="copyright">Copyright &copy;2022 <a href="/">ELSA</a> - All Rights Reserved.</p>
    </footer>
  )
}

export default Footer;
